import { Link } from "react-router-dom";

interface InternalLink {
  text: string;
  href: string;
  description: string;
}

interface InternalLinkingBoostProps {
  currentPage: string;
  links?: InternalLink[];
}

export const InternalLinkingBoost = ({ currentPage, links }: InternalLinkingBoostProps) => {
  const defaultLinks: InternalLink[] = [
    {
      text: "Secondary Glazing Services",
      href: "/secondary-glazing",
      description: "Explore our comprehensive range of secondary glazing solutions"
    },
    {
      text: "London Service Areas",
      href: "/locations",
      description: "Find secondary glazing services in your London borough"
    },
    {
      text: "Sash Window Glazing Units",
      href: "/vertical-sliding-units-glazing",
      description: "Discover which glazing solution suits your window type"
    },
    {
      text: "Get a Free Quote",
      href: "/get-quote",
      description: "Request your free, no-obligation secondary glazing quote"
    },
    {
      text: "Case Studies",
      href: "/case-studies",
      description: "See real examples of our secondary glazing installations"
    },
    {
      text: "Secondary Glazing Blog",
      href: "/blog-secondary-glazing",
      description: "Latest insights and guides on secondary glazing"
    }
  ];

  const displayLinks = (links || defaultLinks).filter(link => link.href !== currentPage);

  if (displayLinks.length === 0) return null;

  return (
    <nav aria-label="Related pages" className="my-8 p-6 bg-muted/30 rounded-lg border border-border">
      <h2 className="text-xl font-semibold mb-4 text-foreground">Related Resources</h2>
      <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {displayLinks.slice(0, 6).map((link, index) => (
          <li key={index}>
            <Link 
              to={link.href}
              className="group block p-3 rounded-md hover:bg-muted/50 transition-colors"
            >
              <span className="font-medium text-primary group-hover:underline">
                {link.text}
              </span>
              <p className="text-sm text-muted-foreground mt-1">
                {link.description}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
